import { Icon, IconProps } from '@chakra-ui/react'

export function AddCheck(props: IconProps) {
  return (
    <Icon viewBox="0 0 32 32" fill="none" {...props}>
      <g clipPath="url(#clip0_658_11759)">
      <path
        d="M26.6666 2.66663H10.6666C9.19996 2.66663 7.99996 3.86663 7.99996 5.33329V21.3333C7.99996 22.8 9.19996 24 10.6666 24H26.6666C28.1333 24 29.3333 22.8 29.3333 21.3333V5.33329C29.3333 3.86663 28.1333 2.66663 26.6666 2.66663ZM26.6666 21.3333H10.6666V5.33329H26.6666V21.3333ZM16.6266 18.6666L12 14L13.8666 12.12L16.6266 14.8933L23.4666 7.99996L25.3333 9.87996L16.6266 18.6666ZM5.33329 26.6666H24V29.3333H5.33329C3.86663 29.3333 2.66663 28.1333 2.66663 26.6666V7.99996H5.33329V26.6666Z"
        fill="currentColor"
      />
      </g>
      <defs>
      <clipPath id="clip0_658_11759">
      <rect width="32" height="32" fill="white"/>
      </clipPath>
      </defs>
    </Icon>
  )
}
